import React from 'react';
import moment from 'moment';
import Select from 'react-select';
import { downloadFile, filterSelect } from 'src/utils/utils';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';

import AppStockModalAdd from './appStockModalAdd';
import AppStockModalOut from './appStockModalOut';

import ringAnim from 'src/images/anim/ring.svg';
import SubNavBar from '../components/SubNavBar';
import Card from 'src/components/Card';
import CardTitle from 'src/components/CardTitle';
import SearchCard from 'src/scenes/appStock/components/SearchCard';
import Button from 'src/components/Button';
import withAuth from 'src/hoc/withAuth';

const linkToProductHardware = '/dashboard/productHardware/';
const apiReference = '/api/productReferenceHardware/';
const apiSupplier = '/api/supplierHardware/';
const apiStock = '/api/stock/';
const apiProductsAdd = '/api/stock/addProduct/';
const apiProductsCancel = '/api/stock/cancel/';
const apiProductsWithdraw = '/api/stock/withdrawProduct/';
const apiProductsPutBack = '/api/stock/putBackProduct/';
const apiSearch = '/api/stock/searchProducts/';

class AppStock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      filterProductDate: true, // DESC
      offsetProduct: 0,
      dataProduct: undefined, // products displayed inside the table
      dataRef: undefined,
      dataSupplier: undefined,
      dataStock: undefined,
      selectedStock: undefined,
      queryString: undefined,
      searchRefId: -1,
      searchStockId: -1,
      searchSupplierId: -1,
      isModalProductAddOpen: false,
      isModalProductOutOpen: false,
      modalOutPurpose: 'withdraw',
      urlBarCode: undefined,
    };

    this.listProductCancel = undefined;
    this.rowsTotal = {};

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.postProducts = this.postProducts.bind(this);
    this.postFinish = this.postFinish.bind(this);
    this.cancelProducts = this.cancelProducts.bind(this);
    this.handleProducts = this.handleProducts.bind(this);
    this.printErrorLog = this.printErrorLog.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
    this.seeMore = this.seeMore.bind(this);
    this.componentCleanup = this.componentCleanup.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleInputSelectChange(val) {
    const value = val ? val['id'] : -1;

    this.setState({
      searchRefId: value,
    });
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.componentCleanup);

    let queryURL = apiReference;
    let graphQL = '{ productReferencesHardware{ id, wording } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['productReferencesHardware']) {
          this.setState({
            dataRef: data['data']['productReferencesHardware'],
          });
        }
      });
    ///////////////////////////////////////
    let queryURL2 = apiSupplier;
    let graphQL2 = '{ suppliersHardware{ id, name} }';
    queryURL2 += graphQL2;
    this.props
      .authFetch(queryURL2, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['suppliersHardware']) {
          this.setState({
            dataSupplier: data['data']['suppliersHardware'],
          });
        }
      });
    ///////////////////////////////////////
    let queryURL3 = apiStock;
    let graphQL3 = '{ stocks{ id, name} }';
    queryURL3 += graphQL3;
    this.props
      .authFetch(queryURL3, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['stocks']) {
          this.setState({
            dataStock: data['data']['stocks'],
          });
        }
      })
      .catch(() => {
        console.log('erreur fetch stock list');
      });
    ////////////////////////////////////////
    let search = {
      queryString: undefined,
      stockID: -1,
      refID: -1,
      supplierID: -1,
    };
    this.refreshSearch(search, 0);
  }

  toUnicode = (input) => {
    return input.replace(/#/g, function (char) {
      return '\\u' + ('0000' + char.charCodeAt(0).toString(16)).substr(-4);
    });
  };

  refreshSearch(search, offsetNb) {
    this.setState({ pendingHasMoreProduct: true });
    let queryURL = apiSearch;
    let graphQL =
      '{products(stockId:' +
      search.stockID +
      ', referenceId:' +
      search.refID +
      (!!search.queryString ? `, referenceName:"${this.toUnicode(search.queryString)}"` : '') +
      ', supplierId:' +
      search.supplierID +
      ', offset:' +
      itemsPerPage['product_stock'] * offsetNb +
      ', limit:' +
      itemsPerPage['product_stock'] +
      '){ hasMore, items{ id, stickerId, dateDelivery, reference{ id, wording, supplierHardware{ id, name } }, stock{ id, name } } } }';
    queryURL += encodeURIComponent(graphQL);

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['products']['items']) {
          this.setState({
            offsetProduct: offsetNb, // increment or reset the current offset
            hasMoreProduct: data['data']['products']['hasMore'],
            pendingHasMoreProduct: false,
            dataProduct:
              offsetNb > 0
                ? this.state.dataProduct.concat(data['data']['products']['items'])
                : data['data']['products']['items'],
          });
        }
      });
  }

  componentCleanup() {
    // this will hold the cleanup code
    if (this.listProductCancel) {
      this.cancelProducts();
    }
  }

  componentWillUnmount() {
    this.componentCleanup();
    window.removeEventListener('beforeunload', this.componentCleanup); // remove the event handler for normal unmounting
  }

  shouldComponentUpdate(nextProps, nextState) {
    let search = {
      queryString: this.state.queryString,
      stockID: this.state.searchStockId,
      refID: this.state.searchRefId,
      supplierID: this.state.searchSupplierId,
    };
    if (nextState.searchStockId !== this.state.searchStockId) {
      search.stockID = nextState.searchStockId;
      this.refreshSearch(search, 0);
    }
    if (nextState.searchRefId !== this.state.searchRefId) {
      search.refID = nextState.searchRefId;
      this.refreshSearch(search, 0);
    }
    if (nextState.searchSupplierId !== this.state.searchSupplierId) {
      search.supplierID = nextState.searchSupplierId;
      this.refreshSearch(search, 0);
    }
    if (nextState.queryString !== this.state.queryString) {
      search.queryString = nextState.queryString;
      this.refreshSearch(search, 0);
    }

    return true;
  }

  seeMore() {
    let search = {
      queryString: this.state.queryString,
      stockID: this.state.searchStockId,
      refID: this.state.searchRefId,
      supplierID: this.state.searchSupplierId,
    };
    this.refreshSearch(search, this.state.offsetProduct + 1);
  }

  handleSearchReference = ({ queryString }) => {
    this.setState({ queryString });
  };

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  toggleDateFiltering(type) {
    this.setState({
      // reset filter
      [type]: !this.state[type],
    });
  }

  render() {
    const { dataRef } = this.state;
    const { dataStock } = this.state;
    const { dataSupplier } = this.state;
    const { dataProduct } = this.state;

    let NoProduct = this.state.dataProduct && this.state.dataProduct.length === 0 ? <span>Aucun produit.</span> : '';

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Gestion stock'
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button
              onClick={() => this.openModal('product-add')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-plus'>Ajouter</span>
            </button>
            <button
              onClick={() => this.openModal('product-putback')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-forward'>Remettre</span>
            </button>
            <button
              onClick={() => this.openModal('product-withdraw')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-minus'>Retirer</span>
            </button>
            <button
              onClick={() => this.openModal('product-remove')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-cross'>Supprimer</span>
            </button>
          </div>
        </SubNavBar>

        <div id='appViewContent'>
          <SearchCard onSubmit={this.handleSearchReference} />

          <Card className='mb-5'>
            <CardTitle title='Gestion des stocks' />
            <table className='table'>
              <thead>
                <tr>
                  <th>
                    <select
                      name='searchStockId'
                      value={this.state.searchStockId}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                      id='exampleSelect1'
                    >
                      <option value={-1}>Stock</option>
                      {dataStock ? (
                        dataStock.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </th>
                  <th>
                    <Select
                      className='select-stock-search form-control'
                      name='searchRefId'
                      value={this.state.searchRefId}
                      labelKey={'wording'}
                      valueKey={'id'}
                      options={dataRef}
                      onChange={this.handleInputSelectChange}
                      noResultsText={'Aucun résultat'}
                      placeholder={'Référence'}
                      clearValueText={'Supprimer'}
                      ignoreCase={false}
                      filterOption={filterSelect}
                    />
                  </th>
                  <th>
                    <select
                      name='searchSupplierId'
                      value={this.state.searchSupplierId}
                      onChange={this.handleInputChange}
                      className='select-stock-search form-control'
                      id='exampleSelect1'
                    >
                      <option value={-1}>Fournisseur</option>
                      {dataSupplier ? (
                        dataSupplier.map((data) => (
                          <option value={data.id} key={data.id}>
                            {data.name}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </th>
                  <th className='cursor' onClick={() => this.toggleDateFiltering('filterProductDate')}>
                    Rentré le{' '}
                    <span className={'icon icon-triangle-' + (this.state.filterProductDate ? 'down ' : 'up ')}></span>
                  </th>
                  <th>Num Série</th>
                </tr>
              </thead>
              <tbody>
                {dataProduct ? (
                  dataProduct
                    .sort((a, b) =>
                      this.state.filterProductDate
                        ? new Date(b.dateDelivery) - new Date(a.dateDelivery)
                        : new Date(a.dateDelivery) - new Date(b.dateDelivery)
                    )
                    .map((data, i) => (
                      <tr key={i}>
                        <td>{data.stock.name}</td>
                        <td>{data.reference.wording}</td>
                        <td>{data.reference.supplierHardware.name}</td>
                        <td>{moment(data.dateDelivery).format('DD-MM-YY | HH:mm')}</td>
                        <th scope='row'>
                          <Link to={linkToProductHardware + data.id}>{data.stickerId}</Link>
                        </th>
                      </tr>
                    ))
                ) : (
                  <span>Chargement...</span>
                )}
              </tbody>
            </table>
            {this.state.hasMoreProduct && (
              <div className='list-see-more text-center'>
                {this.state.pendingHasMoreProduct ? (
                  <img src={ringAnim} />
                ) : (
                  <Button color='primary' variant='outlined' onClick={this.seeMore}>
                    Voir plus
                  </Button>
                )}
              </div>
            )}
            {NoProduct}
          </Card>
        </div>

        <AppStockModalAdd
          urlBarCode={this.state.urlBarCode}
          dataStock={this.state.dataStock}
          dataHardware={this.state.dataRef}
          className='myModal'
          isOpen={this.state.isModalProductAddOpen}
          openToast={this.props.openToast}
          onPost={(state) => this.postProducts(state)}
          onFinish={this.postFinish}
          onClose={this.closeModal}
        />

        <AppStockModalOut
          className='myModal'
          modalPurpose={this.state.modalOutPurpose}
          isOpen={this.state.isModalProductOutOpen}
          openToast={this.props.openToast}
          onPost={this.handleProducts}
          onClose={this.closeModal}
        />
      </div>
    );
  }

  openModal(type) {
    let toOpen = undefined;
    switch (type) {
      case 'product-add':
        toOpen = 'isModalProductAddOpen';
        break;
      case 'product-withdraw':
        toOpen = 'isModalProductOutOpen';
        this.setState({ modalOutPurpose: 'withdraw' });
        break;
      case 'product-remove':
        toOpen = 'isModalProductOutOpen';
        this.setState({ modalOutPurpose: 'remove' });
        break;
      case 'product-putback':
        toOpen = 'isModalProductOutOpen';
        this.setState({ modalOutPurpose: 'putback' });
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  closeModal() {
    if (this.listProductCancel) {
      this.cancelProducts();
    }
    this.props.toggleBlackOut();
    this.setState({
      isModalProductAddOpen: false,
      isModalProductOutOpen: false,
      urlBarCode: undefined,
    });
  }

  cancelProducts() {
    if (this.listProductCancel) {
      let queryUrl = apiProductsCancel;
      let data = 'data=' + encodeURIComponent(JSON.stringify(this.listProductCancel));
      this.props
        .authFetch(queryUrl, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          method: 'POST',
          body: data,
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data.isValid) {
              this.props.openToast(true, 'Opération correctement annulée');
              this.listProductCancel = undefined;
            } else {
              this.printErrorLog();
              this.props.openToast(false, 'Une erreur a eu lieu. Veuillez consulter le fichier log-produit');
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            this.printErrorLog();
            this.props.openToast(false, 'Une erreur a eu lieu. Veuillez consulter le fichier log-produit');
            console.log('stock error \n' + error);
          }.bind(this)
        );
    }
  }

  handleProducts(purpose, products) {
    if (products) {
      let queryUrl = '';
      switch (purpose) {
        case 'withdraw':
          queryUrl = apiProductsWithdraw;
          break;
        case 'remove':
          queryUrl = apiProductsCancel;
          break;
        case 'putback':
          queryUrl = apiProductsPutBack;
          break;
      }
      let data = 'data=' + encodeURIComponent(JSON.stringify(products));
      this.props
        .authFetch(queryUrl, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          method: 'POST',
          body: data,
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data.isValid) {
              this.props.openToast(true, 'Opération réalisée avec succès');
              this.componentDidMount();
            } else {
              let message =
                data.error && data.error !== ''
                  ? data.error
                  : "Une erreur a eu lieu. Il est possible que l'opération ne soit pas applicable sur certains des produits sélectionnés";
              this.props.openToast(false, message);
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            this.props.openToast(false, 'Une erreur a eu lieu.');
            console.log('stock error \n' + error);
          }.bind(this)
        );
    }
  }

  printErrorLog() {
    if (this.listProductCancel) {
      let filename = 'log-produit.txt';
      let text = 'Erreur apparu le ' + moment().format('DD-MM-YY | HH:mm:ss') + ' \n\n';
      text += 'Liste des codes-barre à supprimer: \n\n';

      for (let i = 0; i < this.listProductCancel.products.length; i++) {
        text += this.listProductCancel.products[i].stickerId;
        text += i === this.listProductCancel.products.length - 1 ? '' : ', \n';
      }

      downloadFile(filename, text);
      this.listProductCancel = undefined;
    }
  }

  postProducts(json) {
    let queryURL = apiProductsAdd;
    let graphQL =
      '{ products(quantity:' +
      json.quantity +
      ', stock:{id:' +
      json.stock.id +
      '}, reference:{id:' +
      json.product.reference.id +
      '} ){ id, stickerId } }';
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        let jsonBarCode = {
          products: data['data']['products'],
          refID: json.product.reference.id,
          stockID: json.stock.id,
          date: moment().format('DD-MM-YY | HH:mm'),
        };

        this.setState({
          urlBarCode: jsonBarCode,
        });
        this.listProductCancel = jsonBarCode;
        this.props.openToast(true, 'Produits ajoutés au stock');
      })
      .catch(() => {
        this.props.openToast(false, 'Erreur ajout des produits');
      });
  }

  postFinish() {
    this.listProductCancel = undefined;
    this.props.openToast(true, 'Opération réalisée avec succès');
    this.componentDidMount();
  }
}

export default withAuth(AppStock);
